import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { Loader2 } from "lucide-react";
import { API, authed } from "@/lib/api";
import { ConfigProvider } from "@/context/ConfigContext";
import { Denied } from "@/components/admin/AdminGuard";

// Loads the school the admin is working on; backend checks ownership.
export default function SchoolScope({ children }) {
  const { schoolId } = useParams();
  const { getToken } = useAuth();
  const [school, setSchool] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setSchool(null);
    setError(null);
    (async () => {
      try {
        const { data } = await axios.get(`${API}/schools/${schoolId}`, await authed(getToken));
        setSchool(data);
      } catch (e) {
        setError(e.response?.status || 500);
      }
    })();
  }, [schoolId, getToken]);

  if (error) return <Denied title={error === 404 ? "School not found" : "No access to this school"} />;
  if (!school) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;
  return <ConfigProvider initial={school.config} slug={school.slug}>{children}</ConfigProvider>;
}
